import { render } from "./IndustryInformation.vue?vue&type=template&id=2288262b&scoped=true"
import script from "./IndustryInformation.vue?vue&type=script&lang=js"
export * from "./IndustryInformation.vue?vue&type=script&lang=js"

import "./IndustryInformation.vue?vue&type=style&index=0&id=2288262b&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2288262b"]])

export default __exports__